<template>
  <div>
    <applications-seller-header></applications-seller-header>
    <applications-seller-steps></applications-seller-steps>
  </div>
</template>

<script>
import ApplicationsSellerHeader from './header';
import ApplicationsSellerSteps from './steps/';

export default {
  name: 'ApplicationsSeller',
  components: {
    ApplicationsSellerHeader,
    ApplicationsSellerSteps,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  methods: {
    async getApplication() {
      if (this.id) {
        await this.$store.commit('setIsAppLoading', true);
        await this.$store.dispatch('seller/fetchApplication', this.id);
        await this.$store.commit('setIsAppLoading', false);
        await this.checkApplication();
      } else {
        await this.$store.commit('seller/resetApplication');
      }
    },
    async checkApplication() {
      if (!this.$store.getters['seller/getId']) {
        this.$notify({
          title: 'Başvuru Formu Bulunamadı',
          text: 'Sistemde kayıtlı böyle bir başvuru bulunamadı',
        });
        await this.$store.commit('seller/setSavedApplicationId', null);
        setTimeout(() => {
          this.$router.push({ name: 'applications.seller' });
        });
      }
    },
    async checkIfUserCanResumeApplication() {
      const savedApplicationId = this.$store.getters[
        'seller/getSavedApplicationId'
      ];

      if (!this.id && savedApplicationId) {
        const title = 'Kayıtlı Satış Noktası Başvurusu';
        const body = `
          Daha önceden yarım bıraktığınız bir başvuru bulunmaktadır. Devam etmek ister misiniz?
          <br><br>
          <em><b>Not:</b> Hayır'ı seçerseniz daha oluşturmuş olduğunuz kayıtlı başvurunuz silinecektir.</em>
        `;

        const isConfirmed = await this.$confirm({ title, body });

        if (isConfirmed) {
          this.$router.replace({
            params: {
              id: savedApplicationId,
            },
          });
        } else {
          await this.$store.commit('seller/setSavedApplicationId', null);
        }
      }
    },
  },
  async created() {
    await this.checkIfUserCanResumeApplication();
    await this.getApplication();
  },
  beforeDestroy() {
    this.$confirmCloseAll();
  },
  async destroyed() {
    await this.$store.commit('seller/resetApplication');
  },
};
</script>
